'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactPropertiesActionTypes = (0, _keyMirror2.default)({
  REQUESTED_CONTACT_PROPERTY: null,
  RECEIVED_CONTACT_PROPERTY_SUCCESS: null,
  RECEIVED_CONTACT_PROPERTY_FAILED: null
});

exports.default = ContactPropertiesActionTypes;
module.exports = exports['default'];